import { CardContent, Divider, Tooltip, Typography, Box, Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";


const CoApplicantSummary = (props) => {
    const {t} = useTranslation();

    return (
        <div>
            <div className="edit">
                <h3>
                    {t("Co Applicant Details")}{" "}
                    {`(${props?.coapplicants?.length})`}
                </h3>
                {
                    props?.edit &&

                    <Button
                        onClick={props?.onEditCoApplicantsFunc}
                        style={{
                            backgroundColor: "#00634a",
                            color: "white",
                            textTransform: "none",
                            paddingBottom: "3px",
                            marginLeft: "10px"
                        }}
                    >
                        {t("Edit")}
                    </Button>
                }

            </div>
            <div className="coapplicants" onClick={(e) => { e.preventDefault() }}>
                {props?.coapplicants?.map(
                    (item, index) => (
                        <Box
                            // sx={{
                            //     padding: 0,
                            //     border: "1px solid #ccc",
                            //     borderRadius: 2,
                            //     boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                            //     marginTop: "10px",
                            //     marginBottom: "10px",
                            //     width: "100%"
                            // }}
                            className="coapplicant-card"
                        >
                            <CardContent
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    padding: 2,
                                }}
                            >
                                <Typography
                                    variant="subtitle1"
                                    sx={{ fontWeight: "bold" }}
                                >
                                    {t("Co-Applicant")} {index + 1}
                                </Typography>
                                <Typography
                                    style={{ color: "rgba(0, 0, 0, 0.5)" }}
                                >
                                    {t("Borrower Name")}:{" "}
                                    {item.FirstName + " " + item.LastName}
                                </Typography>
                                <Divider sx={{ margin: "6px 0" }} />
                                <Typography>
                                    <span
                                        style={{
                                            display: "inline-block",
                                            textAlign: "left",
                                            color: "rgba(0, 0, 0, 0.5)",
                                        }}
                                    >
                                        {t("Phone")}:
                                    </span>
                                    <span
                                        style={{
                                            display: "inline-block",
                                            textAlign: "right",
                                        }}
                                    >
                                        {item.Phone}
                                    </span>
                                </Typography>
                                <Typography style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'flex-start',
                                    alignItems: 'center'
                                }}>
                                    <span
                                        style={{
                                            display: "inline-block",
                                            textAlign: "left",
                                            color: "rgba(0, 0, 0, 0.5)",
                                        }}
                                    >
                                        {t("Email")}:
                                    </span>
                                    <Tooltip title={item.Email} arrow placement="top" leaveTouchDelay={10000} enterTouchDelay={0}>
                                        <span
                                            style={{
                                                display: "inline-block",
                                                textAlign: "left",
                                                maxWidth: "290px",
                                                overflow: "hidden",
                                                whiteSpace: "nowrap",
                                                textOverflow: "ellipsis"
                                            }}
                                        >
                                            &nbsp;{item.Email?.toLowerCase()}
                                        </span>
                                    </Tooltip>
                                </Typography>
                            </CardContent>
                        </Box>
                    )
                )}
            </div>
        </div>
    )
}
export default CoApplicantSummary;